module.exports = __webpack_public_path__ + "media/brands/mueller_mitteltal-2469ba16.png";